import { useOptionalAuth } from "../auth/AuthProvider";
import { currentUser } from "./firebaseAuth";
import { useEffect, useState } from "react";
import { subscribeAuth } from "./firebaseAuth";

/**
 * Compatibility adapter. Prefer useAuth() inside AuthProvider.
 */
export function useBillingAuth() {
  const ctx = useOptionalAuth();
  const [fallbackUser, setFallbackUser] = useState(() => currentUser());
  const [fallbackReady, setFallbackReady] = useState(Boolean(ctx));

  useEffect(() => {
    if (ctx) return undefined;
    const unsub = subscribeAuth((next) => {
      setFallbackUser(next);
      setFallbackReady(true);
    });
    return unsub;
  }, [ctx]);

  if (ctx) {
    return {
      user: ctx.user,
      ready: ctx.ready,
      signedIn: ctx.signedIn,
      email: ctx.email,
      uid: ctx.uid,
      generation: ctx.scope?.generation ?? null,
      phase: ctx.phase,
      signIn: ctx.signIn,
      signOut: ctx.signOut,
    };
  }

  return {
    user: fallbackUser,
    ready: fallbackReady,
    signedIn: Boolean(fallbackUser),
    email: fallbackUser?.email || null,
    uid: fallbackUser?.uid || null,
    generation: null,
    phase: null,
    signIn: null,
    signOut: null,
  };
}
